<div soho-busyindicator
  [style.height]="'100%'"
  [text]="' '"
  [blockUI]="true"
  [displayDelay]="20"
  [timeToComplete]="this.uiLoadingIndicatorTimeout"
  [transparentOverlay]="false"
  >
  @if (contextForm) {
    <section class="scrollable-flex-header expandable-area" [class.is-expanded]="formState?.contextFormExpanded">
      <div class="expandable-pane">
        <div class="content">
          <lm-form-content-form #LMContextForm
            [formSpec]="contextForm.busFormSpec"
            [formOptions]="formOptions"
            [specFields]="specFields"
            [placeHolder]="placeHolder"
            [layout]="contextForm.busFormSpec.busFormLayoutSpec.layout"
            [model]="model"
            (fieldEvent)="onFieldEvent($event)"
          ></lm-form-content-form>
        </div>
      </div>
      <div class="expandable-footer">
        <button id="composite-form-expander" class="btn-tertiary expandable-expander">
          <span>{{contextFormExpanderButtonText}}</span>
        </button>
      </div>
    </section>
  }

  <!--need template for column filtering -->
  @if (showRowFilter || showDateRangeFilter) {
    <div class="lm-matrix-filter-container">
      <!--    <div *ngIf="showRowFilter" class="lm-matrix-row-filter" [style.width.px]="frozenColumnWidth">-->
      <!--      <div class="field" [style.width.%]="100">-->
      <!--        <label for="header-filter" aria-label="Header Filter" style="display: none;">Header Filter</label>-->
      <!--        <input type="text" id="header-filter" name="header-filter" />-->
    <!--      </div>-->
  <!--    </div>-->
  @if (showDateRangeFilter) {
    <div class="lm-matrix-column-filter">
      <button (click)="onPrevious()" soho-button="icon" icon="previous-page" title="Previous Date Range" [disabled]="dateModel.date === '' ? true : false">Previous Record</button>
      <div class="field">
        <label for="range-novalue" aria-label="Range - No Initial value" style="display: none;">Range - No Initial value</label>
        <input (change)="onDateRangeFilter()" (keyup.enter)="onDateRangeFilter()" [(ngModel)]="dateModel.date" soho-datepicker [options]="sohoDatePickerOptions" [mode]="'standard'" id="range-novalue" name="range-novalue" class="datepicker input-md" type="text"/>
      </div>
      <button (click)="onNext()" soho-button="icon" icon="next-page" title="Next Date Range" [disabled]="dateModel.date === '' ? true : false">Next Record</button>
    </div>
  }
</div>
}

<div class="lm-matrix-datagrid-container" (click)="onDataGridClicked($event)">
  @if (formSpec) {
    <lm-list-datagrid-wrapper #DatagridWrapper
      [dataGridId]="datagridId"
      (cellchange)="onCellChange($event)"
      (contextMenu)="onContextMenu($event)"
      (rowActivated)="onRowActivated($event)"
      (rowDeactivated)="onRowDeactivated($event)"
      (rowClicked)="onRowClicked($event)"
      (rowDoubleClicked)="onRowDoubleClicked($event)"
      (selected)="onRowSelected($event)"
    ></lm-list-datagrid-wrapper>
  }
</div>
</div>
<div #matrixDialog>
  <!-- dialog placeholder used to display action form from menu -->
</div>

